<template>
  <el-drawer :visible.sync="drawerVisible" :with-header="false" :size="size">
    <div v-infinite-scroll="load" :class="`waterfall${parseInt(size)}`">
      <el-card :body-style="{marginBottom:'10px'}" class="waterfall-item" shadow="hover" v-for="( item,index ) in historyFileList" :key="index">
        <div class="hs-fl">
          <p class="pic-name confont-style">{{item.filename}}</p>
          <img v-if="item.isImg" :src="item.url" style="width: 100%" />
          <div v-else class="file-icon drawer-file-icon" :class="`file-icon-${item.ext}`"></div>
          <el-button icon="el-icon-document-copy" type="primary" :style="{marginTop: '5px',width:'100%'}" v-clipboard:copy="item.url" v-clipboard:success="onCopy">复制路径</el-button>
        </div>
      </el-card>
    </div>
  </el-drawer>
</template>


<script>
export default {
  name: 'fileListDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    history: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: '50%'
    }
  },
  data () {
    return {
      count: 10, // 显示文件个数
      historyFileList: [] // 历史文件列表
    };
  },
  watch: {
    history (val) {
      // 当传入的文件列表改变时 重新显示新的默认数据
      this.historyFileList = val.slice(0, 20) // 截取数组
    }
  },
  computed: {
    drawerVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
  },
  methods: {
    // 每次加载20个文件
    load () {
      if (this.historyFileList.length < this.history.length) {
        this.count += 20;
        this.historyFileList = this.history.slice(0, this.count) // 截取数组
      }
    },
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.waterfall-close-icon {
  position: absolute;
  width: 20px;
  height: 40px;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  > i {
    position: absolute;
    width: 20px;
    height: 40px;
    line-height: 40px;
    border-radius: 0 40px 40px 0;
    color: #041677;
    font-weight: 700;
    background-color: #fbfbff;
    cursor: pointer;
  }
}
.pic-name {
  margin: 0 0 14px 0;
  text-align: left;
  background: #efefef;
  font-size: 14px;
  // color: rgba(0, 0, 0, 0.65);
  padding: 5px 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.waterfall100 {
  padding: 20px;
  width: 100%;
  min-height: 100%;
  column-gap: 15px;
  column-count: 6;
  margin: 0 auto;
}
.waterfall80 {
  padding: 20px;
  width: 100%;
  min-height: 100%;
  column-gap: 12px;
  column-count: 5;
  margin: 0 auto;
}
.waterfall50 {
  padding: 20px;
  width: 100%;
  min-height: 100%;
  column-gap: 10px;
  column-count: 4;
  margin: 0 auto;
}
.waterfall-item {
  img {
    width: 100%;
  }
  margin-bottom: 15px;
  break-inside: avoid;
  // border: 1px solid #000;
}

@media (min-width: 992px) and (max-width: 1300px) {
  .waterfall100 {
    column-count: 5;
    .drawer-file-icon {
      height: 150px;
      background-size: 100% 150px;
    }
  }
  .waterfall80 {
    column-count: 5;
    .drawer-file-icon {
      height: 150px;
      background-size: 100% 150px;
    }
  }
  .waterfall50 {
    column-count: 3;
    .drawer-file-icon {
      height: 150px;
      background-size: 100% 150px;
    }
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .waterfall100 {
    column-count: 4;
    .drawer-file-icon {
      height: 120px;
      background-size: 100% 120px;
    }
  }
  .waterfall80 {
    column-count: 3;
    .drawer-file-icon {
      height: 120px;
      background-size: 100% 120px;
    }
  }
  .waterfall50 {
    column-count: 2;
    .drawer-file-icon {
      height: 120px;
      background-size: 100% 120px;
    }
  }
}
@media (min-width: 600px) and(max-width: 767px) {
  .waterfall100 {
    column-count: 3;
    .drawer-file-icon {
      height: 100px;
      background-size: 100% 100px;
    }
  }
  .waterfall80 {
    column-count: 2;
    .drawer-file-icon {
      height: 100px;
      background-size: 100% 100px;
    }
  }
  .waterfall50 {
    column-count: 2;
    .drawer-file-icon {
      height: 100px;
      background-size: 100% 100px;
    }
  }
}
@media (max-width: 599px) {
  .waterfall100 {
    column-count: 2;
    .drawer-file-icon {
      height: 50px;
      background-size: 100% 50px;
    }
  }
  .waterfall80 {
    column-count: 2;
    .drawer-file-icon {
      height: 50px;
      background-size: 100% 50px;
    }
  }
  .waterfall50 {
    column-count: 2;
    .drawer-file-icon {
      height: 50px;
      background-size: 100% 50px;
    }
  }
  .drawer-file-icon {
    height: 50px;
    background-size: 100% 50px;
  }
}
</style>